import { jsx } from 'react/jsx-runtime';
import { HORIZONTAL_BAR_LABEL_HEIGHT, FONT_SIZE } from '@shopify/polaris-viz-core';

function Label({
  barHeight,
  color,
  label,
  labelWidth,
  y
}) {
  const labelYOffset = barHeight / 2;
  return /*#__PURE__*/jsx("text", {
    height: HORIZONTAL_BAR_LABEL_HEIGHT,
    width: labelWidth,
    "aria-hidden": "true",
    y: y + labelYOffset,
    fontSize: `${FONT_SIZE}px`,
    fill: color,
    dominantBaseline: "central",
    children: label
  });
}

export { Label };
